<template>
     <keep-alive
            v-if="!(blackRoutePath.some((nav, index) => nav === $route.path))"
          >
            <router-view ></router-view>
          </keep-alive>
          <router-view v-else></router-view>
  <!-- <keep-alive >
    <router-view/>
  </keep-alive> -->
       
    
  
</template>
<script>
import { BLACK_ROUTE_PATH } from "@/page/commons/BoskTabNavigation/constant";
export default {
    name:'operation-layout',
    data(){
      return{
        blackRoutePath:[]
      }
    },
    created(){
      this.blackRoutePath=[...BLACK_ROUTE_PATH]
    }
}
</script>